import script from "./confirm-delete-segment-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./confirm-delete-segment-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__